import script from "./editAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./editAccountView.vue?vue&type=script&setup=true&lang=js"

import "./editAccountView.vue?vue&type=style&index=0&id=e8923c2c&lang=scss&scoped=true"
import "./editAccountView.vue?vue&type=style&index=1&id=e8923c2c&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8923c2c"]])

export default __exports__